import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import Menu, { MenuItem, MenuSeparator } from '../ui/Menu'
import { getUserInitials } from '../../utils/userInitials'

interface HeaderUserMenuProps {
  name: string
  onLogout: () => void | Promise<void>
}

const HeaderUserMenu: React.FC<HeaderUserMenuProps> = ({ name, onLogout }) => {
  const navigate = useNavigate()
  const initials = getUserInitials(name)

  return (
    <Menu
      align="right"
      triggerAriaLabel={`Konto: ${name}`}
      trigger={
        <span
          aria-hidden
          className="flex h-8 w-8 items-center justify-center rounded-full bg-ink text-paper font-serif text-xs leading-none"
        >
          {initials}
        </span>
      }
      triggerClassName="p-0.5"
    >
      {(close) => (
        <>
          <MenuItem
            onClick={() => {
              close()
              navigate('/account/watchlist')
            }}
          >
            Watchlist
          </MenuItem>
          <MenuItem
            onClick={() => {
              close()
              navigate('/account')
            }}
          >
            Indstillinger
          </MenuItem>
          <MenuSeparator />
          <MenuItem
            icon={<LogOut className="h-3.5 w-3.5" />}
            onClick={() => {
              close()
              void onLogout()
            }}
          >
            Log ud
          </MenuItem>
        </>
      )}
    </Menu>
  )
}

export default HeaderUserMenu
